import { css } from '@emotion/css'

export default {
    btnLearnMore: css({
        position: 'relative',
        maxWidth: '158px',
    }),
    spriteOne: css({
        position: 'absolute',
        top: '-22px',
        left: '-8px',
        maxWidth: '59px'
    }),
    spriteTwo: css({
        position: 'absolute',
        bottom: '-26px',
        right: '-20px',
        maxWidth: '75px'
    }),
    headline: css({
        position: 'relative',
        maxWidth: '300px',
        marginBottom: 10,
    }),
    containerDoughMain: css({
        textAlign: 'center',
        position: 'absolute',
        left: '50%;',
        top: '55%',
        transform: 'translate(-50%,-50%)'
    })
}